import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { bindActionCreators } from 'redux';
import { toggleAddModal, setDetails, changeAddModalStep } from 'focus_groups/ducks/view_state';
import DetailsForm from 'focus_groups/components/details_form';

export const FOCUS_GROUP_DETAILS_FORM = 'FOCUS_GROUP_DETAILS_FORM';

export function validate(values) {
  const errors = {};
  if (!values.name) {
    errors.name = 'Please enter a name for this focus group';
  }

  if (!values.purpose) {
    errors.purpose = 'Please enter a purpose for this focus group';
  }

  return errors;
}

export function mapStateToProps(state) {
  const { focusGroups } = state.project;
  const { details } = focusGroups.viewState;

  return {
    initialValues: details || { share_results: true },
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    toggle: toggleAddModal,
    onSubmit: (formData) => (dispatch) => {
      dispatch(setDetails(formData));
      dispatch(changeAddModalStep(2));
    }
  }, dispatch);
}

const DetailsReduxForm = reduxForm({
  form: FOCUS_GROUP_DETAILS_FORM,
  validate,
})(DetailsForm);

export default connect(mapStateToProps, mapDispatchToProps)(DetailsReduxForm);



// WEBPACK FOOTER //
// ./focus_groups/containers/details_form.js